import { useQuery } from '@tanstack/react-query';
import { ehiService, EhiOptions } from '@/services/ehi.service';

export const EHI_OPTIONS_QUERY_KEY = ['ehi', 'options'] as const;

/** Словники фільтрів журналу EHI (рівні, користувачі зі знімками) - з бекенду, локалізовані. */
export const useEhiOptions = () => {
  const { data, isLoading, error, refetch } = useQuery<EhiOptions>({
    queryKey: EHI_OPTIONS_QUERY_KEY,
    queryFn: ehiService.getOptions,
    staleTime: 5 * 60 * 1000,
  });

  return {
    levels: data?.levels ?? [],
    users: data?.users ?? [],
    isLoading,
    error,
    refetch,
  };
};
